<template>
  <div class="prepay-detail">
    <h3>预付款详情</h3>
    <el-form
      :model="prepayInfo"
      :rules="rules"
      ref="prepayInfo"
      class="demo-form-inline"
      size="mini"
      label-width="180px"
    >
      <el-form-item label="订单号">
        {{ id }}
      </el-form-item>
      <el-form-item label="预付金额">
        {{ prePayPending }}
      </el-form-item>
      <el-form-item label="户名" prop="accountName">
        <el-input type="text" v-model="prepayInfo.accountName"></el-input>
      </el-form-item>
      <el-form-item label="付款账号" prop="cardNo">
        <el-input type="text" v-model="prepayInfo.cardNo"></el-input>
      </el-form-item>
      <el-form-item label="开户行" prop="bank">
        <el-input type="text" v-model="prepayInfo.bank"></el-input>
      </el-form-item>
      <el-form-item label="到账时间" prop="arrivalTime">
        <el-date-picker
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择到账时间"
          v-model="prepayInfo.arrivalTime"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到账凭证" prop="accountReceipt">
        <el-upload
          class="avatar-uploader"
          action="https://up-z1.qbox.me/"
          :show-file-list="false"
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
          :data="uploadData"
        >
          <img
            v-if="prepayInfo.accountReceipt"
            :src="prepayInfo.accountReceipt"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <el-input
            type="hidden"
            v-model="prepayInfo.accountReceipt"
          ></el-input>
        </el-upload>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="submit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import api from "../api";
const { prepay, upload } = api;
import moment from "moment";

export default {
  name: "prepayDetail",
  data() {
    return {
      prePayPending: 0,
      prepayInfo: {
        accountName: "",
        cardNo: "",
        bank: "",
        accountReceipt: "",
        arrivalTime: "",
      },
      uploadData: {
        token: "",
        name: "",
        chunk: 0,
        chunks: 1,
      },
      rules: {
        accountName: [
          {
            required: true,
            message: "请输入户名",
            trigger: "blur",
          },
        ],
        cardNo: [
          {
            required: true,
            message: "请输入付款账号",
            trigger: "blur",
          },
        ],
        bank: [
          {
            required: true,
            message: "请输入开户行",
            trigger: "blur",
          },
        ],
        /*
                accountReceipt: [{
                    required: true,
                    message: '请上传到账凭证',
                    trigger: 'change'
                }, ],*/
        arrivalTime: [
          {
            required: true,
            message: "请填写到账时间",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  watch: {},
  mounted() {
    this.fetch();
    this.getToken();
  },
  methods: {
    async getToken() {
      let res = await upload.token();
      if (res.data.code == 200) {
        this.uploadData.token = res.data.data.up_token;
      }
    },
    async fetch() {
      let obj = {
        id: this.id,
      };

      let res = await prepay.list(obj);
      this.list = res.data.data;
      let { code, data } = res.data;

      data = data[0];
      if (code == 200) {
        this.prepayInfo.accountName = data.accountName;
        this.prepayInfo.cardNo = data.cardNo;
        this.prepayInfo.bank = data.bank;
        this.prepayInfo.accountReceipt = data.accountReceipt;
        this.prepayInfo.arrivalTime = data.arrivalTime;
        this.prePayPending = data.prePayPending;
      }
    },
    submit() {
      this.$refs.prepayInfo.validate((valid) => {
        if (valid) {
          this.update();
        } else {
          return false;
        }
      });
    },
    async update() {
      let obj = this.prepayInfo;
      obj.id = this.id;
      let res = await prepay.update(obj);
      if (res.data.code == 200) {
        this.$message.success("保存成功");
        setTimeout(() => {
          window.location.href = "/prepay";
        }, 2000);
      }
    },
    handleSuccess(res, file) {
      this.prepayInfo.accountReceipt = `https:\/\/image.duiyou360.com/${res.key}`;
    },
    beforeUpload(file) {
      const sizeM = file.size / 1024 / 1024;
      this.chunks = Math.ceil(sizeM / 10); // 大于10m文件进行分片
      this.uploadData.name = file.name;

      /*
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
            */
    },
  },
};
</script>
<style scoped>
.demo-form-inline {
  width: 640px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/finance/prepay-detail.vue